export default __webpack_public_path__ + "img/youtube.9e7c6a0a4a3d2ad81cad6d19a8958cf9.svg";